import { useEffect, useState } from "react";
import { ACTIVE_BRANDS } from "@/data/catalog";
import BrandCard from "@/components/BrandCard";
import { fetchProducts } from "@/lib/api";

export default function BrandSection() {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    fetchProducts()
      .then((list) => {
        const m = {};
        list.forEach((p) => (m[p.brandSlug] = (m[p.brandSlug] || 0) + 1));
        setCounts(m);
      })
      .catch(() => {});
  }, []);

  // Show active brands that actually have inventory.
  const brands = ACTIVE_BRANDS.filter((b) => (counts[b.slug] || 0) > 0);
  const list = brands.length > 0 ? brands : ACTIVE_BRANDS;

  return (
    <section className="border-b border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="mb-10 max-w-2xl">
          <span className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-sky-700">Manufacturers</span>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">Shop by Brand</h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            We carry equipment from established HVAC manufacturers. Select a brand to filter the catalog automatically.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {list.map((b) => <BrandCard key={b.slug} brand={b} count={counts[b.slug] ?? null} />)}
        </div>
      </div>
    </section>
  );
}
